// extracted by mini-css-extract-plugin
export default {"mac-inp":"macMaskComponentStyle_mac-inp__4fwwG"};